import { useIntl } from '@weenat/wintl'
import { useNavigate } from 'app/routx-router'
import Button from 'app/src/kit/Button'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'

export const Component = () => {
  const { t } = useIntl()
  const nav = useNavigate()
  return (
    <>
      <Text $fontSize='lg'>{t('auth.verification_success_title')}</Text>
      <div>
        <EmptyStateWithRipple
          tint={'feedback.success.500'}
          Icon={Icons.CheckCircle}
          title={t('auth.verification_success_title')}
          description={t('auth.verify_email_success_description')}
        >
          <Button
            onPress={() => {
              nav('/', { replace: true })
            }}
          >
            {t('actions.go_back_to_app')}
          </Button>
        </EmptyStateWithRipple>
      </div>
    </>
  )
}
export default Component
